import {
  CopyrightOutlined,
  DesktopOutlined,
  FileOutlined,
  LogoutOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
  PieChartOutlined,
  TeamOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Breadcrumb, Layout, Menu } from "antd";
import React, { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import { MainLayoutProps } from "../models/main_layout_props";
import { logoutUserRequest } from "../store/slices/user-slice";
import { AppDispatch } from "../store/types/store";
import { Confirm } from "./Confirm";
import { SideBar } from "./SideBar";
import { useLocation } from "react-router-dom";

const { Content, Footer } = Layout;

const MainLayout: React.FC<MainLayoutProps> = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);
  const [showConfirmModel, setShowConfirmModel] = useState(false);
  const dispatch: AppDispatch = useDispatch();
  const [breadcrumbPath, setBreadCrumbPath] = useState<string[]>([]);
  
  const location = useLocation();
  
  const handleLogout = () => {
    setShowConfirmModel(true);
  };
  
  useEffect(() =>{
    const path = location.pathname?.split('/').filter(str => str.trim() !== "");
    
    setBreadCrumbPath(path)
  }, [location.pathname])

  const capitalizeFirstLetter = (str: string) => {
    return str.charAt(0).toUpperCase() + str.slice(1);
  };

  return (
    <Layout className="layout-wrapper">
      <SideBar
        collapsed={collapsed}
        setCollapsed={setCollapsed}
        handleLogout={handleLogout}
      />
      <Layout>
        <Content className="content_wrapper">
          <Breadcrumb style={{ margin: "16px 0" }}>
            {breadcrumbPath.map((value, index) => {
              return(
                <Breadcrumb.Item key={index}>{capitalizeFirstLetter(value)}</Breadcrumb.Item>
              )
            })}
          </Breadcrumb>
          <div className="content_sub_wrapper">{children}</div>
        </Content>
        <Footer className="footer-wrapper"><p><CopyrightOutlined /> <span style={{fontSize: 14}}>Symmatics 2025</span></p></Footer>
      </Layout>
      <Confirm
        open={showConfirmModel}
        hideModal={() => setShowConfirmModel(false)}
        proceedButton={() => {
          dispatch(logoutUserRequest());
          // setShowConfirmModel(false);
        }}
        okText={"Logout"}
        cancelText={"Cancel"}
      />
    </Layout>
  );
};

export { MainLayout };
